/**
 * Stałe bez zależności od bazy danych / mysql2.
 *
 * Wydzielone z src/lib/config.ts, żeby komponenty klienckie mogły je importować
 * bez wciągania do bundla przeglądarki całego DatabaseManagera (mysql2 + zależności).
 * src/lib/config.ts re-eksportuje te stałe dla kompatybilności wstecznej po stronie serwera.
 */

/**
 * Nagłówki cache - dla kompatybilności wstecznej
 * Preferuj używanie getCacheHeaders() z site-config
 */
export const CACHE_CONTROL_HEADERS = {
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  'Pragma': 'no-cache',
  'Expires': '0'
};

/**
 * Domyślne dane kontaktowe - dla kompatybilności wstecznej
 * Dane są teraz ładowane z site-config.json
 */
export const DEFAULT_CONTACT_INFO = {
  company_name: 'Ośrodek Szkolenia Morskiego LIBRA',
  address_line1: 'ul. Portowa 37',
  address_line2: '78-100 Kołobrzeg',
  phone1: 'tel/fax: 94 355 47 45',
  phone2: 'tel. kom.: 600 909 200',
  email: 'info@szkoleniamorskie.pl',
  opening_hours: 'Poniedziałek - Piątek: 9:00 - 15:00\nSobota - Niedziela: Zamknięte',
  bank_info: 'PKO BP\n93 1020 2821 0000 1502 0148 4245'
};
